@import '~style-sheet-helpers/core.less';

.notes-column {
  font-size: 0;
  height: 30px;
}

.note-icon-wrapper {
  display: inline-block;
  vertical-align: top;
}
